import i18n from 'core/pkg/translation/i18n'

export default {
  init(options = {}, services) {
    i18n.init(
        Object.assign({}, {
          lng: 'en',
          debug: false,
          defaultNS: 'common',
          resources: {},
        }, options),
        (err, t) => {
          if (err) {
            throw console.log('Cant load languages', err)
          }
        })
    return i18n
  }
}
